import { TYPE } from '../actions/types'

export default function (state = {}, action) {
    switch (action.type) {
        case TYPE.GET_SOLD_OUT_DATES:
            return { ...state, response: action.payload }
        case TYPE.UPDATE_SOLD_OUT_DATE:
            return { ...state, response: action.payload }
        case TYPE.HOTEL_SOLD_OUT:
            return { ...state, response: action.payload }
        default:
            return state;
    }
}

